import { CalculationUtils } from "./CalculationUtils";

export class tabellaRiepilogativa {

    tabella: tabellaDiRiepilogo
    classiDiametricheExtended: IClasseDiametrica[];
    specie: string[];
    constructor(classiDiametricheExtended?: IClasseDiametrica[]) {
        this.classiDiametricheExtended = classiDiametricheExtended;
        this.tabella = {
            pianteAdEttaro: [],
            areaBasimetricaAdEttaro: [],
            diametroMedio: [],
            altezzaMedia: [],
            volumeAdEttaro: [],
        }
        if (this.classiDiametricheExtended) {
            this.specie = this.classiDiametricheExtended.map(m => m.specieArborea.value).filter((v, i, a) => a.indexOf(v) === i);
            this.tabella.pianteAdEttaro = this.pianteAdEttaro();
            this.tabella.areaBasimetricaAdEttaro = this.areaBasimetricaAdEttaro();
            this.tabella.diametroMedio = this.getdiametroMedio();
            this.tabella.altezzaMedia = this.altezzaMedia();
            this.tabella.volumeAdEttaro = this.volumeAdEttaro();
        }
    }

    private pianteAdEttaro(): { specie: string, value: number }[] {
        const result: { specie: string, value: number }[] = [];
        this.specie.forEach(specie => {
            const rows = this.classiDiametricheExtended.filter(f => f.specieArborea.value === specie);
            result.push({ specie, value: rows.map(m => m.numeroPianteAdEttaro).reduce((a, b) => a + b) })
        })
        return result;
    }

    private areaBasimetricaAdEttaro(): { specie: string, value: number }[] {
        const result: { specie: string, value: number }[] = [];
        this.specie.forEach(specie => {
            const rows = this.classiDiametricheExtended.filter(f => f.specieArborea.value === specie);
            result.push({ specie, value: rows.map(m => m.areaBasimetricaAdEttaro).reduce((a, b) => a + b) })
        })
        return result;
    }

    private getdiametroMedio(): { specie: string, value: number }[] {
        const result: { specie: string, value: number }[] = [];
        this.specie.forEach(specie => {
            const areaBasimetricaAdEttaro = this.tabella.areaBasimetricaAdEttaro.find(f => f.specie === specie)?.value || 0;
            const pianteAdEttaro = this.tabella.pianteAdEttaro.find(f => f.specie === specie)?.value || 0;
            result.push({ specie, value: CalculationUtils.getDiametroMedio(areaBasimetricaAdEttaro, pianteAdEttaro) })
        })
        return result;
    }

    private altezzaMedia(): { specie: string, value: number }[] {
        const result: { specie: string, value: number }[] = [];
        this.specie.forEach(specie => {
            const diametroMedio = this.tabella.diametroMedio.find(f => f.specie === specie)?.value || 0;
            result.push({ specie, value: CalculationUtils.getAltezzaIpsometrica(diametroMedio) })
        })
        return result;
    }
    
    private volumeAdEttaro(): { specie: string, value: number }[] {
        const result: { specie: string, value: number }[] = [];
        this.specie.forEach(specie => {
            const rows = this.classiDiametricheExtended.filter(f => f.specieArborea.value === specie);
            result.push({ specie, value: rows.map(m => m.volumeAdEttaro).reduce((a, b) => a + b) })
        })
        return result;
    }
}